<template>
	<ListContextMenuMobile
		:is-open="isOpen"
		:context-data="contextData"
		:menu-items="menuItems"
		:title="title"
		:blocking="true"
		@close="$emit('close')"
		@item-click="(id, action, data) => $emit('item-click', id, action, data)"
	>
		<template #list-body>
			<tr
				v-for="(item, idx) in menuItems"
				:key="idx"
				class="menu-item"
				:class="{selected: isSelected(item)}"
				@click="handleItemClick(item)"
			>
				<td class="spacer" />
				<td
					v-if="item.label"
					class="menu-item--label"
				>
					{{ item.label }}
				</td>
				<td class="check">
					<Icon
						v-if="isSelected(item)"
						icon-name="check"
						size="lg"
					/>
				</td>
			</tr>
		</template>
	</ListContextMenuMobile>
</template>

<script>
import ListContextMenuMobile from './ListContextMenuMobile';
import ContextMenuMobileMixin from './ContextMenuMobileMixin';

export default {
	name:       'VideoSettingsContextMenuMobile',
	components: { ListContextMenuMobile },
	mixins:     [ContextMenuMobileMixin],
	props:      {
		selected: {
			type: Number,
		},
	},
	methods: {
		isSelected(item) {
			return item.value === this.selected;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.spacer {
	width: 50%;
}

.check {
	margin-left: 10px;
	color: var(--color-hype-yellow);
}

.menu-item {
	&.selected {
		background-color: var(--color-grey-700);
	}

	td { padding: 20px 8px };

	.menu-item--icon {
		width: 50%;
	}
	.menu-item--label {
		text-align: center;
		width: auto;
	}

	.check {
		margin-left: 10px;
		color: var(--color-hype-yellow);
		width: 100%;
	}
}

</style>
